// @ts-nocheck
export const localeCodes =  [
  "en",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46json_4652c591",
      load: () => import("#nuxt-i18n/4652c591" /* webpackChunkName: "locale_en_45US_46json_4652c591" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_45ES_46json_a50d5b0d",
      load: () => import("#nuxt-i18n/a50d5b0d" /* webpackChunkName: "locale_es_45ES_46json_a50d5b0d" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "es",
    name: "Español",
    language: undefined
  }
]
/** client **/

/** client-end **/